
<div class="text-center">

  <ng-container *ngIf="!($loading | async) && ($trialEnd | async)">

    <h1 class="grad-theme-text text-center">All aboard!</h1>
    <p class="text-white fs-4">You're all set, your token balance should update within a minute or two.</p>
    <p>We hope you enjoy using socialyze.</p>
    <button class="btn btn-theme mt-4" (click)="closeModal()">Get Started</button>

  </ng-container>


  <ng-container *ngIf="($loading | async)">
    <h1 class="grad-theme-text text-center">Please wait...</h1>
    <p class="text-white fs-4">We are attempting to process your payment.</p>
  </ng-container>

  <ng-container *ngIf="!($loading | async) && !($trialEnd | async)">
    <h1 class="grad-theme-text text-center">It looks like you have run out of tokens.</h1>
    <p class="text-white fs-4">You've used up all of the tokens available with our trial package.</p>

    <p class="text-white fs-4">We hope you were able to benefit from the power of our software and the data available to you.</p>

    <p class="text-white fs-4">To start using more tokens, you must start your paid plan with us. You can click below to end your trial early.</p>

    <button class="btn btn-theme mt-4" (click)="endTrialEarly()">End trial early</button>
    <p class="text-light mt-3 mb-0" style="cursor: pointer;" (click)="closeModal()">No thanks</p>
  </ng-container>

</div>

